import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAppMeta } from "hooks";
import { useAddFreeUnloadingMutation } from "store/services/shipmentUnLoadingApi";
import DriverUnLoadingShipmentForm from "./ShipmentUnLoadingComponents/DriverUnLoadingShipmentForm";

const DriverUnLoadingShipmentCreateScreen = () => {
    const navigate = useNavigate();
    const breadcrumbs = [
        { title: "Driver Shipment Unloading", path: "/app/driver/unloading" },
        { title: "Unload and Deliver" },
    ];
    const [createFreeUnloading, { isLoading: creatingFreeUnloading }] = useAddFreeUnloadingMutation();

    const handleAddDriverUnLoading = async (data) => {
        try {
            const response = await createFreeUnloading(data).unwrap();
            const unloadingId = response?.unloading?._id;
            toast.success("Driver Shipment Unloading Created!");
            navigate(`/app/driver/unloading/${unloadingId}/detail`);
        } catch (error) {
            toast.error(
                error?.data?.message ?? error.message ?? "Could Not Create Driver Shipment Unloading!"
            );
        }
    };
    useAppMeta("New Free UnLoading");
    return (
        <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingFreeUnloading}>
            <BreadcrumbLayout.Paper>
                <DriverUnLoadingShipmentForm
                    isBusy={creatingFreeUnloading}
                    onSubmit={handleAddDriverUnLoading}
                />
            </BreadcrumbLayout.Paper>
        </BreadcrumbLayout>
    );
};
export default DriverUnLoadingShipmentCreateScreen;